import styled from "styled-components";

export const PaginationWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    margin-top: 20px;
    margin-bottom: 20px;
`;
export const PaginationBlockItemsWrapper = styled.nav`
    display: flex;
    align-items: center;
    gap: 10px;
    align-self: stretch;
`;

export const PaginationWrapperUl = styled.ul`
    display: -ms-flexbox;
    display: flex;
    list-style: none;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    margin: 0;
    padding: 0;
`;
export const PaginationWrapperLi = styled.li`
    list-style-type: none;

    &::before {
        content: '';
        display: none;
    }
`;
export const PaginationWrapperA = styled.a.attrs(({activeStatus}) => ({
    active: activeStatus ? activeStatus : false,
}))`
    display: flex;
    width: 36px;
    height: 36px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 40px;
    border: ${({theme}) => `2px solid ${theme.colors.primary}`};
    background: ${({active, theme}) => (active ? theme.colors.primary : '#FFF')};
    color: ${({active, theme}) => (active ? '#FFF' : theme.colors.primary)};
`;
export const PaginationWrapperButton = styled.button`
    display: flex;
    width: 36px;
    height: 36px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 40px;
    border: ${({theme}) => ` 2px solid ${theme.colors.primary}`};
    background: #FFF;
    cursor: pointer;

    &:disabled {
        border: ${({theme}) => ` 2px solid ${theme.colors.grey}`};
        color: ${({theme}) => theme.colors.grey};
        cursor: unset;
    }
`;